import $ from 'jquery';

$('.product-description__more button').click(function() {
	$(this).remove();
});
